/**
 * record-lock-reason — powód odrzucenia żądania przez blokadę rekordu na czas zadania przycisku SQL.
 *
 * Trasy zapisu i trasy poboczne dokumentu (archiwum, strony, wysyłki, dekretacja wsadowa) odpowiadają
 * 409 `RECORD_LOCKED_BY_RUN`, gdy na dokumencie trwa zadanie przycisku (w kolejce lub w toku). Miejsca bez
 * stanu zadań rekordu (listy, przycisk wysyłki, edytor stron) pokazują wtedy ten sam opis zadania co pasek
 * blokady na karcie — nazwa procedury z odpowiedzi serwera (układu formularza tu nie znamy), godzina, osoba.
 */

import type { TFunction } from 'i18next';

import { runConflictText } from '@/lib/record-procedures/run-texts';
import { extractRunConflict } from '@/lib/record-procedures/runs-api';

const NO_BUTTON_LABELS: ReadonlyMap<string, string> = new Map();

/**
 * Gotowy polski opis blokady, gdy `err` to 409 `RECORD_LOCKED_BY_RUN`; inaczej `null` — wołający pokazuje
 * wtedy swój zwykły komunikat błędu. `i18n` (język do formatu godziny) jest czytany dopiero przy blokadzie.
 */
export function recordLockReason(
  err: unknown,
  t: TFunction,
  i18n: { language: string },
): string | null {
  const conflict = extractRunConflict(err);
  if (conflict?.code !== 'RECORD_LOCKED_BY_RUN') return null;
  return runConflictText(conflict, NO_BUTTON_LABELS, t, i18n.language);
}
